import { CaregiverCallConfirmationType } from '@/shared/call/CaregiverCallConfirmationType';

import { PhoneCallConfirmationView } from './PhoneCallConfirmationView';
import { VideoCallConfirmationView } from './VideoCallConfirmationView';

type CaregiverCallConfirmationViewProps = {
    consultationUid: string;
    confirmationType: CaregiverCallConfirmationType;
    onClose: (isAutoClosed?: boolean) => void;
    onPhoneCallCompleted: () => void;
};

export const CaregiverCallConfirmationView = ({
    confirmationType,
    consultationUid,
    onClose,
    onPhoneCallCompleted,
}: CaregiverCallConfirmationViewProps) => {
    if (confirmationType === CaregiverCallConfirmationType.phone) {
        return (
            <PhoneCallConfirmationView
                consultationUid={consultationUid}
                onClose={onClose}
                onPhoneCallCompleted={onPhoneCallCompleted}
            />
        );
    }

    return (
        <VideoCallConfirmationView
            consultationUid={consultationUid}
            onClose={onClose}
        />
    );
};
